import {
	Component,
	Input,
	OnInit,
	ChangeDetectionStrategy,
} from "@angular/core"
import { CcParamsGen } from "@app/cc-params-gen/cc-params-gen"
import { COMMON_IMPORTS } from "../common-imports"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { NgTemplateOutlet } from "@angular/common"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { GenButtonGroupComponent } from "@app/gen-inputs/gen-button-group/gen-button-group.component"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { TermsSmsComponent } from "@app/terms-sms/terms-sms.component"
import { GenTableDisplayComponent } from "@app/gen-table-display/gen-table-display.component"
@Component({
	selector: "app-cc-params-sms",
	imports: [
		COMMON_IMPORTS,
		LangValPipe,
		NgTemplateOutlet,
		GenInputComponent,
		GenButtonGroupComponent,
		ModalWrapComponent,
		TermsSmsComponent,
		GenTableDisplayComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./cc-params-sms.component.html",
})
export class CcParamsSmsComponent extends CcParamsGen {
	modalProps: any = null
	//inheriting most functions and fields!
	saveObjName: string = "journal" //which part to save while updating

	saveConsent() {
		this.configcliniq.consent_to_sms_contract = "yes"
		sessionStorage.setItem("cliniqData", JSON.stringify(this.configcliniq))
	}
	validateEntireForm() {
		//validate all fields and detrmine if can be submitted (or has errors)
		let validationFields = {}
		if (this.configcliniq?.consent_to_sms_contract == "yes") {
			validationFields = {
				name_on_message: { not_empty: true, regex: /^([a-zA-Z0-9- .]){1,11}$/ },
			}
		}
		this.isFormSubmittable = this.validator.validateEntireForm(
			this.configcliniq,
			this.errors,
			validationFields
		)
	}
}
